import * as allTools from "./definitions/all.ts";
import {type Tool} from "./types.ts";

const allToolsByConfigName = Object.values(allTools).reduce(
    (acc, tool) => {
        acc[tool.configName] = tool;
        return acc;
    },
    {} as Record<string, Tool>,
);

const allToolsBySlug = Object.values(allTools).reduce(
    (acc, tool) => {
        acc[tool.urlSlug] = tool;
        return acc;
    },
    {} as Record<string, Tool>,
);

export const getToolByConfigName = (configName: string): Tool | undefined => {
    return allToolsByConfigName[configName];
};

export const getToolBySlug = (urlSlug: string): Tool | undefined => {
    return allToolsBySlug[urlSlug];
};
